import { palette } from '@dentalux/ui-library-core/constants'

type ColorScale = Record<number | string, string>

export type AppColors = {
  primary: string
  primaryLight: string
  secondary: string
  white: string
  grey: ColorScale
  error: ColorScale
}

const brandPalette = palette as {
  primary: ColorScale
  secondary: ColorScale
  grey: ColorScale
  error: ColorScale
}

const colors: AppColors = {
  primary: brandPalette.primary[800],
  primaryLight: brandPalette.primary[300],
  secondary: brandPalette.secondary[400],
  white: '#fff',
  grey: brandPalette.grey,
  error: brandPalette.error,
}

export default colors
